/**
 * @generated SignedSource<<eadea57ce2fe3408647887a57bf25eff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CopyPopupGroupInput = {
  clientMutationId?: string | null;
  popupGroupId: string;
  pageId: string;
};
export type PopupGroupCopyButton_Mutation$variables = {
  input: CopyPopupGroupInput;
};
export type PopupGroupCopyButton_MutationVariables = PopupGroupCopyButton_Mutation$variables;
export type PopupGroupCopyButton_Mutation$data = {
  readonly copyPopupGroup: {
    readonly popupGroup: {
      readonly id: string;
      readonly name: string;
      readonly slug: string;
    } | null;
  } | null;
};
export type PopupGroupCopyButton_MutationResponse = PopupGroupCopyButton_Mutation$data;
export type PopupGroupCopyButton_Mutation = {
  variables: PopupGroupCopyButton_MutationVariables;
  response: PopupGroupCopyButton_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CopyPopupGroupPayload",
    "kind": "LinkedField",
    "name": "copyPopupGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PopupGroup",
        "kind": "LinkedField",
        "name": "popupGroup",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupGroupCopyButton_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopupGroupCopyButton_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3b1080be4280c75f518ac12149505c08",
    "id": null,
    "metadata": {},
    "name": "PopupGroupCopyButton_Mutation",
    "operationKind": "mutation",
    "text": "mutation PopupGroupCopyButton_Mutation(\n  $input: CopyPopupGroupInput!\n) {\n  copyPopupGroup(input: $input) {\n    popupGroup {\n      id\n      name\n      slug\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dc731a873860f0313b81d9d64cbff873";

export default node;
